import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useDispatch } from "react-redux";

import { forgotPasswordSchema } from "../../schemas";
import { forgotPassword } from "../../features/userSlice";
import AuthRedirect from "../../components/hoc/AuthRedirect";
import InputField from "../../components/form/InputField";
import { useNotification } from "../../components/notification/NotificationContainer";
import { useEffect } from "react";
import axiosClient from "../../api/axios";

const ForgotPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues: {
      email: "",
    },
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addNotification = useNotification();

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(forgotPassword(data));
      if (forgotPassword.fulfilled.match(res)) {
        addNotification("Password change request successful", "success");
        navigate("/login");
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (err) {
      addNotification(err.message, "warniing");
    }
  };

  return (
    <>
      <AuthRedirect>
        <div className="auth-container">
          <div className="auth-content ">
            <div className=" auth-inner-content ">
              <h2 className="auth-title">Forgot Password</h2>
              <p>{errors.root?.message}</p>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="flex flex-col gap-y-3 pb-5"
              >
                <InputField
                  register={register}
                  errors={errors.email}
                  label="Email"
                  name="email"
                  placeholder="user@example.com"
                  type="email"
                />
                <button className="auth-btn inline-block py-4" type="submit">
                  Submit
                </button>
              </form>
              <p className="text-xs text-center">
                Already have an account?{" "}
                <Link
                  to="/login"
                  className="text-indigo-600 underline hover:text-indigo-800"
                >
                  Sign In
                </Link>
              </p>
            </div>
          </div>
        </div>
      </AuthRedirect>
    </>
  );
};

export default ForgotPassword;
